import { render } from "./MultiSelectUsers.vue?vue&type=template&id=e59d55f0&scoped=true"
import script from "./MultiSelectUsers.vue?vue&type=script&lang=js"
export * from "./MultiSelectUsers.vue?vue&type=script&lang=js"

import "./MultiSelectUsers.vue?vue&type=style&index=0&id=e59d55f0&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59d55f0"]])

export default __exports__